export type Cluster = "localnet" | "devnet" | "mainnet";

const cluster = (import.meta.env.VITE_CLUSTER ?? "devnet") as Cluster;

export const env = {
  apiOrigin: (import.meta.env.VITE_API_ORIGIN ?? "http://localhost:8080").replace(/\/$/, ""),
  privyAppId: import.meta.env.VITE_PRIVY_APP_ID ?? "",
  cluster,
  explorer: import.meta.env.VITE_EXPLORER ?? "https://explorer.solana.com/tx/{sig}?cluster=devnet",
  clientVersion: "web-0.1.0",
};

export const apiBase = `${env.apiOrigin}/v1`;

const RPC_BY_CLUSTER: Record<Cluster, string> = {
  localnet: "http://127.0.0.1:8899",
  devnet: "https://api.devnet.solana.com",
  mainnet: "https://api.mainnet-beta.solana.com",
};

export const rpcUrl = RPC_BY_CLUSTER[cluster];

/** Chain id used in Sign In With Solana and Wallet Standard `chain` fields. */
export const solanaChain = cluster === "mainnet" ? "solana:mainnet" : cluster === "devnet" ? "solana:devnet" : "solana:localnet";

export function explorerTx(signature: string): string {
  return env.explorer.includes("{sig}") ? env.explorer.replace("{sig}", signature) : `${env.explorer.replace(/\/$/, "")}/${signature}`;
}

export function explorerAddress(address: string): string {
  const suffix = cluster === "mainnet" ? "" : `?cluster=${cluster === "localnet" ? "custom" : cluster}`;
  return `https://explorer.solana.com/address/${address}${suffix}`;
}
